import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { OfficiumPages } from '../components/kb/OfficiumPages';

const getToken = () => localStorage.getItem('token');

export default function OfficiumPagesWorkspace() {
  const [user, setUser] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/me`, {
      headers: { Authorization: `Bearer ${getToken()}` }, signal: controller.signal
    }).then(async response => {
      if (!response.ok) throw new Error('Please sign in to open Officium Pages.');
      setUser(await response.json());
    }).catch(err => { if (err.name !== 'AbortError') setError(err.message); });
    return () => controller.abort();
  }, []);
  return <div className="min-h-screen bg-slate-50" data-testid="kb-standalone-workspace">
    <header className="border-b border-slate-200 px-4 sm:px-8 py-3 bg-white">
      <Link to="/dashboard" data-testid="kb-return-dashboard" className="inline-flex items-center gap-2 text-sm text-slate-600 hover:text-indigo-700"><ArrowLeft className="h-4 w-4" />Back to CRM</Link>
    </header>
    <main className="p-4 sm:p-8 min-w-0">
      {error ? <p data-testid="kb-workspace-error" role="alert" className="text-red-700">{error}</p> : user ?
        <OfficiumPages standalone getAuthToken={getToken} currentUser={user} /> : <p data-testid="kb-workspace-loading" role="status">Opening Officium Pages…</p>}
    </main>
  </div>;
}